import { Injectable } from "@angular/core";
import { SettingsService } from "../settings/settings.service";
import { LoggingService } from "./log.service";
import { RestfulService } from "./restful.service";

@Injectable({
  providedIn: "root",
})
export class BackupService {
  private BACKUP_KEY = "backup";
  private DRAFT_KEY = "draft";
  private LOCAL_COPY_KEY = "localCopy";
  sectionToBackup: string[] = ["workflow", "project"];

  backupObject: any = {};

  constructor(private logger: LoggingService, private settings: SettingsService, private restful: RestfulService) {
    this.setupLocalStorage();
  }

  getDraft(key: string): any {
    this.backupObject = this.copy(this.getLocalStorage());
    if (this.isKeyBackuped(key)) {
      if (this.backupObject[key][this.DRAFT_KEY]) {
        return this.backupObject[key][this.DRAFT_KEY];
      }
      console.log(`[BACKUP] In chiave ${key}, bozza non trovata`);
      return null;
    }
  }

  setDraft(key: string, item: any): void {
    this.backupObject = this.copy(this.getLocalStorage());
    if (this.isKeyBackuped(key)) {
      this.backupObject[key][this.DRAFT_KEY] = this.copy(item);
      this.setLocalStorage();
    }
  }

  /**
   * Rimuove dagli elementi salvati la bozza
   */
  removeDraft(key: string): void {
    this.backupObject = this.copy(this.getLocalStorage());
    if (this.isKeyBackuped(key)) {
      this.backupObject[key][this.DRAFT_KEY] = null;
      this.setLocalStorage();
    }
  }

  getSaved(key: string, itemId: number): any {
    if (this.isKeyBackuped(key)) {
      if (this.backupObject[key]) {
        const idxItem = this.backupObject[key][this.LOCAL_COPY_KEY].findIndex((el:any) => el.id === itemId);
        if (idxItem > -1) {
          return this.backupObject[key][this.LOCAL_COPY_KEY][idxItem];
        }
      }
      console.log(`[BACKUP] In chiave ${key}, el con id ${itemId} non trovato`);
      return null;
    }
  }

  setSaved(key: string, item: any): void {
    this.backupObject = this.copy(this.getLocalStorage());
    if (this.isKeyBackuped(key)) {
      if (this.backupObject[key]) {
        const idxItem = this.backupObject[key][this.LOCAL_COPY_KEY].findIndex((el:any) => el.id === item.id);
        if (idxItem > -1) {
          this.backupObject[key][this.LOCAL_COPY_KEY][idxItem] = this.copy(item);
        }
      } else {
        this.backupObject[key] = this.newBackupKey();
        this.backupObject[key][this.LOCAL_COPY_KEY].push(item);
      }
      this.setLocalStorage();
    }
  }

  /**
   * Rimuove dagli elementi salvati l'elemento con id `itemId`
   */
  removeSaved(key: string, itemId: number): void {
    this.backupObject = this.copy(this.getLocalStorage());
    if (this.isKeyBackuped(key)) {
      const idxItem = this.backupObject[key][this.LOCAL_COPY_KEY].findIndex((el:any) => el.id === itemId);
      if (idxItem > -1) {
        this.backupObject[key][this.LOCAL_COPY_KEY].splice(idxItem, 1);
      }
      this.setLocalStorage();
    }
  }

  setupLocalStorage(): void {
    const lsClone = localStorage.getItem(this.BACKUP_KEY);
    if (lsClone != null) {
      this.backupObject = JSON.parse(lsClone);
    } else {
      for (const bs of this.sectionToBackup) {
        this.backupObject[bs] = this.newBackupKey();
      }
    }
    this.setLocalStorage();
  }

  private cleanBackupKey(key: string): void {
    this.backupObject = this.copy(this.getLocalStorage());
    this.backupObject[key] = this.newBackupKey();
  }

  private newBackupKey(): any {
    const obj = {draft: null, localCopy : null };

    obj[this.DRAFT_KEY] = null;
    obj[this.LOCAL_COPY_KEY] = [];
    return obj;
  }

  private copy(item: any): any {
    return JSON.parse(JSON.stringify(item));
  }

  private isKeyBackuped(key: string): boolean {
    return this.sectionToBackup.includes(key);
  }

  private setLocalStorage(): void {
    localStorage.setItem(this.BACKUP_KEY, JSON.stringify(this.backupObject));
  }

  private getLocalStorage(): any {
    const res = localStorage.getItem(this.BACKUP_KEY);
    return JSON.parse(res || '');
  }
}
